export const LIST_EXAMINATION_RESULT_RECAP_REQUEST = 'LIST_EXAMINATION_RESULT_RECAP_REQUEST'
export const LIST_EXAMINATION_RESULT_RECAP_SUCCESS = 'LIST_EXAMINATION_RESULT_RECAP_SUCCESS'
export const LIST_EXAMINATION_RESULT_RECAP_FAIL = 'LIST_EXAMINATION_RESULT_RECAP_FAIL'

export const EXPORT_EXAMINATION_RESULT_RECAP_REQUEST = 'EXPORT_EXAMINATION_RESULT_RECAP_REQUEST'
export const EXPORT_EXAMINATION_RESULT_RECAP_SUCCESS = 'EXPORT_EXAMINATION_RESULT_RECAP_SUCCESS'
export const EXPORT_EXAMINATION_RESULT_RECAP_FAIL = 'EXPORT_EXAMINATION_RESULT_RECAP_FAIL'

export const DOWNLOAD_FILE_EXAMINATION_RESULT_RECAP_REQUEST = 'DOWNLOAD_FILE_EXAMINATION_RESULT_RECAP_REQUEST'
export const DOWNLOAD_FILE_EXAMINATION_RESULT_RECAP_SUCCESS = 'DOWNLOAD_FILE_EXAMINATION_RESULT_RECAP_SUCCESS'
export const DOWNLOAD_FILE_EXAMINATION_RESULT_RECAP_FAIL = 'DOWNLOAD_FILE_EXAMINATION_RESULT_RECAP_FAIL'